"use strict";
jQuery.fn.hasAttr = function (name) {
    var val = this.attr(name);
    return (typeof val !== "undefined") && (val !== false);
};